import { useEffect, useState } from 'react';
import { API } from '../api';
import './Nosotros.css';
import fondoNosotros from '../assets/Nosotros-bg.jpg';
import integrante1 from '../assets/integrante1.jpeg';
import integrante2 from '../assets/integrante2.jpeg';
import integrante3 from '../assets/integrante3.jpeg';

function Nosotros() {
  const [empresa, setEmpresa] = useState(null);

  useEffect(() => {
     window.scrollTo(0,0);
    API.get('empresa/')
      .then(res => setEmpresa(res.data[0]))
      .catch(err => console.log(err));
  }, []);

  if (!empresa) return <p style={{ textAlign: 'center', marginTop: '80px' }}>Cargando...</p>;

  return (
    <div className="nosotros">

      {/* HERO */}
      <section className="nosotros-hero"    style={{ backgroundImage: `url(${fondoNosotros})` }}>
    
        <div className="nosotros-hero-content">
          <h1>{empresa.nombre}</h1>
          <p>
            Agencia de viajes en Lima especializada en experiencias turísticas únicas,
            seguras y personalizadas para viajeros nacionales y extranjeros.
          </p>
        </div>
      </section>

      {/* QUIÉNES SOMOS */}
      <section className="nosotros-section">
      <h2 className="section-title">¿QUIÉNES SOMOS?</h2>
        <p>
          Somos {empresa.nombre} una agencia de turismo en Perú reconocida por su excelencia en el servicio y su compromiso
          con la calidad para todos los viajeros. Nos apasiona conectar a las personas con la cultura, la naturaleza y 
          la historia de cada destino, ofreciendo servicios personalizados, seguros y de alta calidad. 
          Nuestro equipo de profesionales diseña itinerarios únicos, cuidando cada detalle para que 
          nuestros viajeros disfruten con confianza, comodidad y tranquilidad. Creemos que viajar no
           es solo conocer lugares, sino vivir momentos que se convierten en recuerdos para toda la vida.
          Explora los emocionantes destinos turísticos con {empresa.nombre}, 
        </p>

        <p>
          Nos encontramos ubicados en Calle A Mz. D Lt. 09 Edilberto Ramos Grupo Red1,
          brindando atención personalizada en un entorno seguro y profesional.
        </p>
      </section>

      {/* MISIÓN Y VISIÓN (BACKEND) */}
      <section className="nosotros-section light">
        <h2 className="section-title">NUESTRA FILOSOFÍA</h2>

        <div className="filosofia-grid">
          <div className="filosofia-card">
            <h3>MISIÓN</h3>
            <p>{empresa.mision}</p>
          </div>

          <div className="filosofia-card">
            <h3>VISIÓN</h3>
            <p>{empresa.vision}</p>
          </div>
        </div>
      </section>

      {/* POR QUÉ ELEGIRNOS (BACKEND) */}
      <section className="nosotros-section">
        <h2 className="section-title">¿POR QUÉ ELEGIRNOS?</h2>
        <p className="destacado-texto">{empresa.por_que_elegirnos}</p>
      </section>

      {/* CERTIFICACIÓN */}
      <section className="nosotros-section light">
        <h2 className="section-title">CERTIFICACIÓN Y CONFIANZA</h2>
        <p>
          Contamos con certificación oficial expedida por el MINCETUR el 22/06/2023
          (Certificado N.º D84-2023-MML-GDE-ST), garantizando estándares de calidad,
          formalidad y seguridad para nuestros clientes.
        </p>
      </section>

      {/* NUESTRO EQUIPO */}
<section className="nosotros-section light equipo-section">
  <h2 className="section-title titulo-equipo">NUESTRO EQUIPO</h2>

  <div className="equipo-grid">

    <div className="equipo-card">
      <img src={integrante1} alt="Integrante 1" />
      <h3>Dennis Alfaro</h3>
      <p>Asesora de Viajes</p>
    </div>

    <div className="equipo-card">
      <img src={integrante2} alt="Integrante 2" />
      <h3>Luis Kennedy</h3>
      <p>Guía Oficial</p>
    </div>

    <div className="equipo-card">
      <img src={integrante3} alt="Integrante 3" />
      <h3>Miriam Barreto</h3>
      <p>Atención al Cliente</p>
    </div>

  </div>
</section>


    </div>
  );
}

export default Nosotros;
